<template>
  <div class="search-container">
    <input
      id="search-input"
      name="search-input"
      v-bind:value="value"
      v-on:input="$emit('input', $event.target.value)"
      class="sidebar-search"
      placeholder="Search"
    />
    <label
      v-on:click="clear"
      class="clear-button"
      v-bind:class="{ 'can-clear': value }"
      for="search-input"
    >
      <span>
        <i v-if="!value" class="fa fa-search"></i>
        <div v-if="value">&times;</div>
      </span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
  },

  methods: {
    clear() {
      this.$emit('input', '');
    },
  },
};
</script>

<style lang="scss" scoped>
.search-container {
  margin-right: 0.25rem;
  position: relative;
  width: 100%;
}

.sidebar-search {
  border: 1px solid #ccc;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 300;
  padding: 0.5rem 1.5rem 0.25rem;
  padding-right: 3.5rem;
  box-sizing: border-box;
  width: 100%;
}

label.clear-button {
  color: lightgray;
  display: block;
  font-size: 24px;
  position: absolute;
  top: 5px;
  right: 7px;
  width: 24px;
  height: 24px;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: text;

  &.can-clear {
    cursor: pointer;
  }

  &.clear-button-inactive {
    opacity: 0;
  }
}

label.clear-button i.fa-search {
  font-size: 16px !important;
  position: relative;
  top: -4px;
  right: 3px;
}

label.clear-button span {
  position: relative;
  top: -5px;
  right: -5px;
}

.sidebar-search:focus {
  outline: none;
}
</style>
